import { makeObservable, observable } from 'mobx'
import * as R from 'ramda'

class LicenceGroup {
    id

    clientId

    @observable owner

    @observable name

    @observable industry

    @observable eventType

    @observable feature

    @observable startDate

    @observable expiryDate

    @observable period

    @observable licenceType

    @observable licenceCount

    @observable licenceExcempt

    @observable licenceExcemptReason

    @observable crmReference

    constructor({
        id,
        clientId,
        owner,
        name,
        industry,
        eventType,
        feature = [],
        startDate,
        period = 12,
        licenceType,
        licenceCount,
        expiryDate,
        licenceExcempt = false,
        licenceExcemptReason,
        crmReference,
    }) {
        this.id = id
        this.clientId = clientId
        this.owner = owner
        this.name = name
        this.industry = industry
        this.eventType = eventType
        this.feature = feature
        this.startDate = startDate
        this.period = period
        this.licenceType = licenceType
        this.licenceCount = licenceCount
        this.expiryDate = expiryDate
        this.licenceExcempt = licenceExcempt
        this.licenceExcemptReason = licenceExcemptReason
        this.crmReference = crmReference

        makeObservable(this)
    }

    toJSON() {
        return {
            clientId: this.clientId,
            owner: !R.isNil(this.owner) && !R.isEmpty(this.owner) ? this.owner : undefined,
            name: this.name,
            industry: this.industry,
            eventType: this.eventType,
            feature: this.feature,
            startDate: this.startDate,
            expiryDate: this.expiryDate,
            period: this.period,
            licenceType: this.licenceType,
            licenceCount: this.licenceCount,
            licenceExcempt: this.licenceExcempt,
            licenceExcemptReason: this.licenceExcemptReason,
            crmReference: this.crmReference,
        }
    }
}

export default LicenceGroup
